import { LoginLayout } from '@/layouts/LoginLayout';
import { ForgotPasswordForm } from './ForgotPassword';

export const ResetPassword = () => {
  return (
    <LoginLayout>
      <ForgotPasswordForm />
    </LoginLayout>
  );
};
